import axios from 'axios'

export default {
  async login (credentials) {
    return await axios.post('/api/spa/v1/login', credentials)
  },
  async logout () {
    await axios.post('/api/spa/v1/logout')
  },
  async user () {
    return await axios.get('/api/spa/v1/user')
  },
  async csrfCookie () {
    await axios.get('sanctum/csrf-cookie')
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

}
